import { onSnapshot, type QuerySnapshot } from "firebase/firestore";
import { seatingPlansCol } from "@/features/seating/firestore-paths";
import { createSharedSubscription } from "@/lib/firestore/createSharedSubscription";
import { toMillis } from "@/lib/timestamps";
import type { SeatingPlan } from "@amazing-wedding/shared-types";

function parseSeatingPlans(snap: QuerySnapshot): SeatingPlan[] {
  const rows: SeatingPlan[] = [];
  snap.forEach((d) => {
    const data = d.data() as Omit<SeatingPlan, "id">;
    rows.push({ id: d.id, ...data });
  });
  rows.sort((a, b) => toMillis(a.createdAt) - toMillis(b.createdAt));
  return rows;
}

export const seatingPlansSubscription = createSharedSubscription<SeatingPlan[]>({
  getDefault: () => [],
  attach: (weddingId, setSnapshot) => {
    setSnapshot({ data: [], loading: true });
    return onSnapshot(
      seatingPlansCol(weddingId),
      (snap) => {
        setSnapshot({ data: parseSeatingPlans(snap), loading: false });
      },
      () => setSnapshot({ data: [], loading: false }),
    );
  },
});
